import type { AdTile as AdTileType } from "../../shared/types";

export function AdTile({ ad, compact = false }: { ad: AdTileType; compact?: boolean }) {
  return (
    <a
      className={compact ? "ad-tile compact" : "ad-tile"}
      href={ad.targetUrl || "#"}
      style={{ background: ad.background, color: ad.textColor }}
    >
      <span>Sponsored</span>
      {ad.mediaUrl && <img src={ad.mediaUrl} alt="" />}
      <strong>{ad.title}</strong>
      <p>{ad.body}</p>
      <em>{ad.sponsorName} · {ad.ctaLabel}</em>
    </a>
  );
}
